import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Footer from '../components/footer';
import { filterProjects, resetScrollPos } from '../utils/helper-functions';
import HomeAmplified from '../components/home/home-amplified';
import HomeProjects from '../components/home/home-projects';
import HomeServices from '../components/home/home-services';
import HomeApproach from '../components/home/home-approach';
import HomeClients from '../components/home/home-clients';
import HomeCulture from '../components/home/home-culture';
import HomeConnect from '../components/home/home-connect';

class IndexPage extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.location = 'https://www.jkdesign.com';
    }
    resetScrollPos();
    this.props.displayHomeBanner(true);
  }

  componentWillUnmount() {
    this.props.displayHomeBanner(false);
  }

  render() {
    const {
      edges: menuList,
    } = this.props.data.allWordpressWpApiMenusMenusItems;
    const { acf } = this.props.data.allWordpressPage.edges[0].node;
    const { data, browserDetect } = this.props;

    const settings = {
      menus: {
        socialMenuItems: menuList[1].node.items,
        footerMenuItems: menuList[2].node.items,
        infoMenuItems: menuList[3].node.items,
      },
      currentPage: 'IndexPage',
      allWorkData: data.allWordpressWpWork.edges,
      projectList: ['ricoh', 'adp', 'weichert-franchising', 'ad'],
      services: data.allWordpressWpServices.edges,
      awards: acf.footer_awards,
      culture: acf.culture,
      metaTitle: 'JK Design | Creative Marketing Agency',
      meta: [
        {
          title: 'JK Design | Creative Marketing Agency',
          name: 'description',
          content:
            'JK helps you find new, creative ways to connect with the people who matter to your business - with our branding & messaging, employee experience, strategic marketing, and digital services.',
        },
      ],
    };

    const projects = filterProjects(settings.allWorkData, settings.projectList);
    const projectsReArranged = [
      ...projects[3],
      ...projects[1],
      ...projects[2],
      ...projects[0],
    ];

    const {
      headerHeight,
      showHeaderBackdrop,
      hideHeaderBackdrop,
      location,
    } = this.props;

    const { footerMenuItems, socialMenuItems, infoMenuItems } = settings.menus;
    const { awards } = settings;

    return (
      <React.Fragment>
        <Helmet title={settings.metaTitle} meta={settings.meta} />
        <HomeAmplified />
        <HomeProjects projects={projectsReArranged} />
        <HomeServices services={settings.services} />
        <HomeApproach />
        <HomeClients />
        <HomeCulture culture={settings.culture} />
        <HomeConnect locationImages={acf} browserDetect={browserDetect} />
        <Footer
          footerMenuItems={footerMenuItems}
          socialMenuItems={socialMenuItems}
          infoMenuItems={infoMenuItems}
          awards={awards}
        />
      </React.Fragment>
    );
  }
}

IndexPage.propTypes = {
  setBrowser: PropTypes.func,
  showHeaderBackdrop: PropTypes.func,
  hideHeaderBackdrop: PropTypes.func,
  currentPage: PropTypes.string,
};

export default IndexPage;

export const homeQuery = graphql`
  query homeQuery {
    allWordpressWpApiMenusMenusItems(
      sort: { fields: [wordpress_id], order: ASC }
    ) {
      edges {
        node {
          items {
            title
            url
            object_slug
          }
        }
      }
    }
    allWordpressWpWork(sort: { fields: [menu_order] }) {
      edges {
        node {
          title
          slug
          featured_media {
            localFile {
              childImageSharp {
                sizes(quality: 100, maxWidth: 2500, maxHeight: 1406) {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
          }
          acf {
            headline
            button_color
            button_color_dark
            home_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            home_description
            featured_mobile_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressWpServices(sort: { fields: [menu_order] }) {
      edges {
        node {
          title
          slug
          acf {
            cta_message
            internal_info {
              title
            }
          }
        }
      }
    }
    allWordpressPage(filter: { slug: { eq: "home" } }) {
      edges {
        node {
          acf {
            new_york {
              localFile {
                childImageSharp {
                  sizes {
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            new_jersey {
              localFile {
                childImageSharp {
                  sizes {
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            culture {
              localFile {
                childImageSharp {
                  sizes(quality: 100) {
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            footer_awards {
              footer_award_link
              footer_award_image {
                localFile {
                  childImageSharp {
                    sizes {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js